<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t("g.create_at") }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('openSlotsLit.dev_id') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDevName"
            :placeholder="$t('openSlotsLit.dev_id')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.clear" class="search" type="info">{{ $t('g.clear') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" @row-click="func.showDetails" style="width: 100%"
        id="exportTab">
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('openSlotsLit.agent_code')" width="100">
        </el-table-column>
        <el-table-column prop="SiteName" width="120" :label="$t('openSlotsLit.site_name')">
        </el-table-column>
        <el-table-column prop="DevId" :label="$t('openSlotsLit.dev_id')" width="250">
        </el-table-column>
        <el-table-column prop="Temp" :label="$t('device.temp')" width="70">
        </el-table-column>
        <el-table-column prop="MainVer" :label="$t('g.mainControlVersion')" width="100">
        </el-table-column>
        <el-table-column prop="MeasPower" :label="$t('device.meas_power')" width="70">
        </el-table-column>

        <el-table-column prop="LifeTime" :label="$t('device.life_time')" width="120">
          <template #default="scope">
            {{ func.toCounterTime(scope.row.LifeTime) }}
          </template>
        </el-table-column>

        <el-table-column width="100" :label="$t('device.alert')">
          <template #default="scope">
            <el-tag :class="scope.row.Alert == 0 ? 'tag-success' : 'tag-fail'">
              {{ scope.row.Alert == 0 ? $t('g.no') : $t('g.yes') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="100" :label="$t('device.online_status')">
          <template #default="scope">
            <el-tag :class="scope.row.IsOnline == 0 ? 'tag-fail' : 'tag-success'">
              {{ scope.row.IsOnline == 0 ? $t('g.no') : $t('g.yes') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column width="130" :label="$t('device.status')">
          <template #default="scope">
            <el-tag :class="scope.row.Status == 1 ? 'tag-success' : 'tag-fail'">
              {{ scope.row.Status == 1 ? $t('device.statuses.enabled') : $t('device.statuses.disabled') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreatedAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column prop="SlotNum" label="SlotNum" width="120">
        </el-table-column>
        <el-table-column prop="SlotNumEm" label="SlotNumEm" width="120">
        </el-table-column>
        <el-table-column prop="BatRentNum" label="BatRentNum" width="120">
        </el-table-column>
        <el-table-column prop="SlotNumErr" label="SlotNumErr" width="120">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" width="100%" style="margin-top: 0;">
      <el-descriptions border column="4">
        <el-descriptions-item label="ID">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.site_name')">{{ formData.curData.SiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.dev_id')">
          <el-link type="primary" @click="func.togoDiffDetail(formData.curData.DevId)">{{ formData.curData.DevId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('g.mainControlVersion')">{{ formData.curData.MainVer
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.meas_power')">{{ formData.curData.MeasPower
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.electric_quantity')">
          {{ formData.curData.MeasEnergy }}KWH</el-descriptions-item>
        <el-descriptions-item :label="$t('device.online_status')">
          <el-tag :class="formData.curData.IsOnline == 0 ? 'tag-fail' : 'tag-success'">
            {{ formData.curData.IsOnline == 0 ? $t('g.no') : $t('g.yes') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.status')">
          <el-tag :class="formData.curData.Status == 1 ? 'tag-success' : 'tag-fail'">
            {{ formData.curData.Status == 1 ? $t('device.statuses.enabled') : $t('device.statuses.disabled') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.alert')">
          <el-tag :class="formData.curData.Alert == 0 ? 'tag-success' : 'tag-fail'">
            {{ formData.curData.Alert == 0 ? $t('g.no') : $t('g.yes') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.temp')">
          {{ formData.curData.Temp }}&#8451;</el-descriptions-item>
        <el-descriptions-item label="SlotNum">
          {{ formData.curData.SlotNum }}</el-descriptions-item>
        <el-descriptions-item label="SlotNumEm">
          {{ formData.curData.SlotNumEm }}</el-descriptions-item>
        <el-descriptions-item label="SlotNumEmReal">
          {{ formData.curData.SlotNumEmReal }}</el-descriptions-item>
        <el-descriptions-item label="SlotNumErr">
          {{ formData.curData.SlotNumErr }}</el-descriptions-item>
        <el-descriptions-item label="SlotNumBan">
          {{ formData.curData.SlotNumBan }}</el-descriptions-item>
        <el-descriptions-item label="BatRentNum">
          {{ formData.curData.BatRentNum }}</el-descriptions-item>
        <el-descriptions-item label="BatExNum">
          {{ formData.curData.BatExNum }}</el-descriptions-item>
        <el-descriptions-item label="BatReturnNum">
          {{ formData.curData.BatReturnNum }}</el-descriptions-item>
        <el-descriptions-item label="PileNum">
          {{ formData.curData.PileNum }}</el-descriptions-item>

        <el-descriptions-item :label="$t('device.life_time')">
          {{ func.toCounterTime(formData.curData.LifeTime) }}</el-descriptions-item>
        <!-- <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark }}</el-descriptions-item> -->
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
      </el-descriptions>

      <!-- <el-descriptions-item :label="$t('log.message')">{{ formData.curData.SlotInfosStr }}</el-descriptions-item> -->
      <el-table :data="formData.curData.SlotInfosList" :stripe="true" style="width: 100%" id="exportTab2">
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="EboxId" label="EboxId" width="80">
        </el-table-column>
        <el-table-column prop="DevId" label="DevId" width="80">
        </el-table-column>
        <el-table-column prop="SubVer" label="SubVer" width="80">
        </el-table-column>
        <el-table-column prop="Alert" label="Alert" width="80">
        </el-table-column>
        <el-table-column prop="SlotType" label="SlotType" width="80">
        </el-table-column>
        <el-table-column prop="Status" label="Status" width="80">
        </el-table-column>
        <el-table-column prop="SlotStatus" label="SlotStatus" width="80">
        </el-table-column>
        <el-table-column prop="GunStatus" label="GunStatus" width="80">
        </el-table-column>
        <el-table-column prop="DoorStatus" label="DoorStatus" width="80">
        </el-table-column>
        <el-table-column prop="MeasEnergy" label="MeasEnergy" width="80">
        </el-table-column>
        <el-table-column prop="IsPile" label="IsPile" width="80">
        </el-table-column>
        <el-table-column prop="BatId" label="BatId" width="80">
        </el-table-column>
        <el-table-column prop="Voltage" label="Voltage" width="80">
        </el-table-column>
        <el-table-column prop="Current" label="Current" width="80">
        </el-table-column>
        <el-table-column prop="StartTime" label="StartTime" width="80">
        </el-table-column>
        <el-table-column prop="EndTime" label="EndTime" width="80">
        </el-table-column>
        <el-table-column prop="StartTimeStr" label="StartTimeStr" width="80">
        </el-table-column>
        <el-table-column prop="EndTimeStr" label="EndTimeStr" width="80">
        </el-table-column>
        <el-table-column prop="ChargeTime" label="ChargeTime" width="80">
        </el-table-column>
        <el-table-column prop="InitSoc" label="InitSoc" width="80">
        </el-table-column>
        <el-table-column prop="Soc" label="Soc" width="80">
        </el-table-column>
        <el-table-column prop="Soh" label="Soh" width="80">
        </el-table-column>
        <el-table-column prop="Temp" label="Temp" width="80">
        </el-table-column>
        <el-table-column prop="AlertInfo" label="AlertInfo" width="80">
        </el-table-column>
        <el-table-column prop="BatVer" label="BatVer" width="80">
        </el-table-column>
        <el-table-column prop="ChargerVer" label="ChargerVer" width="80">
        </el-table-column>
        <el-table-column prop="CreateAt" label="CreateAt" width="80">
        </el-table-column>
        <el-table-column prop="UpdateAt" label="UpdateAt" width="80">
        </el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.dialogDisplayVisible = false">{{ $t('g.btn_cancel') }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-drawer v-model="formData.devDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <EboxList :propId="formData.curData.DevId"></EboxList>
    </el-drawer>
    <el-drawer v-model="formData.cboxDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <CboxList :propId="formData.curData.DevId"></CboxList>
    </el-drawer>
    <el-drawer v-model="formData.cPileDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <CPileboxList :propId="formData.curData.DevId"></CPileboxList>
    </el-drawer>
    <el-drawer v-model="formData.CarPileDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <CarPileList :propId="formData.curData.DevId"></CarPileList>
    </el-drawer>
  </div>
</template>

<script>
import { reactive, onMounted, computed } from 'vue'
import { shortcuts, operators, cascade_options_direct } from '@/data/default'
import axios from "axios"
import { toDay, toDay2, toCounterTime } from '@/common/func'
import { user, isOperator } from '@/data/token'
import { ElMessage } from 'element-plus'
import i18n from '@/data/i18n/index'
import EboxList from '@/views/ebox/list.vue'
import CboxList from '@/views/cbox/list.vue'
import CarPileList from '@/views/pile/carPile.vue'
import CPileboxList from '@/views/pile/list.vue'
export default {
  name: 'msg',
  components: {
    EboxList,
    CboxList,
    CarPileList,
    CPileboxList,
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const msg = [
      {
        label: t('log.maintain_warehouse'),
        value: '维护开'
      },
      {
        label: t('log.battery_shortage'),
        value: '少电池'
      }, {
        label: t('log.replace_battery'),
        value: '换'
      }, {
        label: t('log.empty_warehouse'),
        value: '假空仓'
      }
    ]
    const render = {
      operators,
      shortcuts,
      msg,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      slots: {},
      curData: {},
      valTime: '',
      valTypes: -1,
      valResult: -1,
      dialogVisible: false,
      dialogDisplayVisible: false,
      devDrawerVisible: false,
      cboxDrawerVisible: false,
      cPileDrawerVisible: false,
      CarPileDrawerVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 0,
      valName: '',
      CodePathID: 0,
      valDevName: '',
      UpdateAtLast: {},//电池更新最后时间
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
    })
    const func = {
      togoDiffDetail(devId) {
        let id = devId.substring(0, 2)
        // formData.devDrawerVisible = true
        if (id == "EC") {
          formData.devDrawerVisible = true
        } else if (id == "CC") {
          formData.cboxDrawerVisible = true
        } else if (id == "CR") {
          formData.cPileDrawerVisible = true
        } else if (id == "CP") {
          formData.CarPileDrawerVisible = true
        } else {
          ElMessage({
            type: 'error',
            message: '数据为空'
          })
          return
        }

      },
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      toCounterTime,
      search() {
        func.loadData()
      },
      clear() {
        formData.CodePathID = 0;
        formData.valDevName = '';
        formData.valphone = '';
        formData.valSiteName = '';
        formData.valTime = '';
        formData.valremark = '';
        formData.valabnormal = '';
        func.loadData()
      },
      rowDblClick(row, column, e) {
        formData.curData = row
        formData.dialogVisible = true
      },
      pageChange(val) {
        func.loadData(val)
      },
      showAddDataDialog() {
        formData.curData = {
        }
        formData.dialogVisible = true
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.CodePathID) {
            params.CodePathId = formData.CodePathID
          }
          if (formData.valDevName) {
            params.DevId = formData.valDevName.trim()
          }
          if (formData.valSiteName) {
            params.SiteName = formData.valSiteName
          }
          if (formData.valphone) {
            params.Mobile = formData.valphone
          }
          if (formData.valabnormal) {
            params.FaultType = formData.valabnormal
          }

          if (formData.valremark) {
            params.Remark = formData.valremark
          }

          if (formData.valTime) {
            params.StartTime = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.EndTime = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          let res = await axios.get(`/admin/boxhis/get`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreateAt)
            try {
              item.SlotInfosList = item.SlotInfos
            } catch (error) {

              item.SlotInfosList = []
            }

          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      token: user.token,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 3rem;
    padding-left: 2rem;
    // background-color: grey;

    // padding-top: 1rem;

    .slots {
      margin-top: 1rem;

      .slot {
        display: flex;
        margin-bottom: 0.5rem;

        >div {
          width: 8rem;

          &:first-child {
            width: 6rem;
          }
        }


      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: left;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 49%;
    }

    &.line-3 {
      :deep(.el-form-item) {
        min-width: 32%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 70rem;
    // width:70vw;
  }
}

@media screen and (max-width:800px) {
  .content {
    >.card-box {
      .inp-list {
        >.item {
          width: 100%;
        }
      }
    }
  }
}
</style>
